module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div style=\"position: absolute; top:0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0, .6); z-index: 1000; display: flex;\"\n	 onclick=\"$(this).remove()\">\n\n	<style>\n		.file-container {\n			margin: 40px;\n\n			flex: 1;\n			align-items: center;\n			align-content: center;\n			justify-content: center;\n			display: inherit;\n		}\n\n		.file-container img {\n			max-width: 100%;\n		}\n	</style>\n\n	<div class=\"file-container\">\n		")
    ;  var file = widget.files[index]; 
    ; __append("\n		<img src=\"")
    ; __append(escapeFn( file.src ))
    ; __append("\"/>\n	</div>\n</div>")
  }
  return __output.join("");

}